<template>
    <div>
        <section>
            <b-field  position="is-right">
                <b-input placeholder="Search..." type="search" icon="search" v-model="search">
                </b-input>
                <p class="control">
                    <b-dropdown class="hover-rotate-90" hoverable aria-role="list" position="is-bottom-left"
                                :disabled="toggleDelete">
                        <button class="button is-primary" slot="trigger">
                            <b-icon icon="plus" pack="fal"></b-icon>
                        </button>

                        <b-dropdown-item v-for="type in communicationTypes" aria-role="listitem"
                                         @click="type.create({name:type.default,type:type.name},true)">
                            <b-icon :icon="type.icon" pack="fad"></b-icon>
                            {{type.title}}
                        </b-dropdown-item>
                    </b-dropdown>
                </p>
                <p class="control">
                    <button class="button is-danger" @click="toggleDelete = !toggleDelete">
                        <b-icon icon="minus" pack="fal"></b-icon>
                    </button>
                </p>
                <p class="control">
                    <button class="button is-success" @click="isPlaceholderCardModalActive = true">
                        <b-icon icon="info" pack="fas"></b-icon>
                    </button>
                </p>
            </b-field>

        </section>
        <section class="arrangement-cards">
            <div class="card is-grid no-footer" v-for="(event, index) in filtered" :class="{ giggly: toggleDelete }">
                <header class="card-header">
                    <p class="card-header-title" v-if="!toggleDelete">
                        <b-icon :icon="icon(event.type)" pack="fad"></b-icon>
                        <span>&nbsp;&nbsp;
                        <a @click="editCommunication(event)">{{event.name}}</a>
                    </span>
                    </p>
                    <p class="card-header-title" v-else>
                        <a @click="removeCommunication(event, index)">
                            <b-icon icon="minus-circle" pack="fad" type="is-danger"></b-icon>
                        </a>
                        <span>&nbsp;&nbsp;{{event.name}}</span>
                    </p>
                </header>
                <!-- <div class="card-content">
                    <div class="content">
                        <strong>Betreff:</strong> {{event.subject}}
                    </div>
                </div> -->
            </div>
        </section>
        <b-modal :active.sync="isCardModalActive" scroll="keep" @close="saveCommunication()" full-screen>
            <div class="card is-modal">
                <header class="card-header">
                    <p class="card-header-title">
                        <b-icon :icon="icon(editableCommunication.type)" pack="fad"></b-icon>&nbsp;&nbsp;{{editableCommunication.name}}
                    </p>
                </header>
                <div class="card-content">
                    <div class="content" v-if="editableCommunication.type == 'external'">
                        <b-field horizontal label="Name" >
                            <b-input v-model="editableCommunication.name"></b-input>
                        </b-field>
                        <b-field horizontal label="Betreff">
                            <b-input :value="editableCommunicationExternal.subject" disabled></b-input>
                        </b-field>
                        <b-field horizontal label="Versanddatum"
                                 v-if="editableCommunicationExternal.scheduleStart">
                            <b-input :value="$moment(editableCommunicationExternal.scheduleStart).format('DD.MM.YYYY')"
                                     disabled></b-input>
                        </b-field>
                        <b-field horizontal label="Versandzeit" >
                            <b-input :value="$moment(editableCommunicationExternal.scheduleStart).format('HH:mm')"
                                     disabled></b-input>
                        </b-field>
                        <strong>Platzhalter:</strong>
                        <b-field horizontal label="QR Code">
                            <b-input :value="placeholder('qr')" disabled icon="qrcode"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('qr'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <b-field horizontal label="Anmelde-Link" >
                            <b-input :value="placeholder('link')" disabled icon="link"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('link'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <b-field horizontal label="Anmelde-URL" >
                            <b-input :value="placeholder('url')" disabled icon="globe"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('url'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <div class="buttons">
                            <b-button type="is-success" @click="saveCommunication()">Speichern</b-button>
                            <b-button type="is-primary" @click="editExternal(editableCommunicationExternal.id)">
                                Bearbeiten
                            </b-button>
                            <b-button type="is-warning" @click="() => {isCardModalActive = false;editableCommunication = {}}">Abbrechen</b-button>
                        </div>
                    </div>
                    <div class="content" v-else>
                        <b-field horizontal label="Name" >
                            <b-input v-model="editableCommunication.name"></b-input>
                            <b-select v-model="editableCommunication.type" placeholder="Bitte wählen Sie den Typ:"
                                      :icon="icon(editableCommunication.type)">
                                <option v-for="type in communicationTypes.filter(t => t.name != 'external')"
                                        :value="type.name">
                                    {{type.title}}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field horizontal label="Betreff">
                            <b-input v-model="editableCommunication.subject"></b-input>
                        </b-field>
                        <b-field horizontal label="Inhalt">
                            <vue-editor id="quillEditor" v-model="editableCommunication.content" useCustomImageHandler
                                        @image-added="handleImageAdded" :editorToolbar="customToolbar"
                                        :customModules="customModulesForEditor"
                                        :editorOptions="editorSettings"></vue-editor>
                        </b-field>
                        <b-field horizontal label="Eingabehilfe" >
                            <b-select v-model="temp.placeholder" placeholder="Bitte wählen"
                                      @input="insertPlaceholder()" :key="temp.reload">
                                <option v-for="placeholder in $root.settings.placeholders"
                                        :value="placeholder.code">
                                    {{placeholder.name}}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field horizontal label="Zielgruppe" >
                            <b-select v-model="editableCommunication.targetgroup" placeholder="Keine Zielgruppe" disabled>
                                <option value="0">
                                    Keine Zielgruppe
                                </option>
                                <option v-for="tg in $root.env.account.targetgroups"
                                        :value="tg.id">
                                    {{tg.name}}
                                </option>

                            </b-select>
                            <p class="control">
                                <b-button
                            </p>
                        </b-field>
                        <b-field horizontal label="Versanddatum" >
                            <Datepicker v-model="editableCommunication.date"
                                        placeholder="Bitte auswählen..." icon="calendar-day" pack="fad">
                            </Datepicker>
                        </b-field>
                        <b-field horizontal label="Versandzeit" >
                            <Timepicker placeholder="Bitte Auswählen..." v-model="editableCommunication.time"
                                        :inline="true"/>
                        </b-field>
                        <div class="buttons">
                            <b-button type="is-success" @click="saveCommunication()">Speichern</b-button>
                            <b-button type="is-success" @click="saveCommunication()" disabled>Aktivieren</b-button>
                            <b-button type="is-primary" @click="previewMail(editableCommunication.id)" disabled>Vorschau öffnen</b-button>
                            <b-button type="is-warning" @click="() => {isCardModalActive = false;editableCommunication = {}}">Abbrechen</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal :active.sync="isPlaceholderCardModalActive" scroll="keep">
            <div class="card is-modal">
                <header class="card-header">
                    <p class="card-header-title">
                        <b-icon icon="info" pack="fad"></b-icon>&nbsp;&nbsp;Allgemeine Platzhalter für Mailingwork
                    </p>
                </header>
                <div class="card-content">
                    <div class="content">
                        <strong>Platzhalter:</strong>
                        <b-field horizontal label="QR Code">
                            <b-input :value="placeholder('qr')" disabled icon="qrcode"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('qr'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <b-field horizontal label="Anmelde-Link" grouped>
                            <b-input :value="placeholder('link')" disabled icon="link"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('link'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <b-field horizontal label="Anmelde-URL" grouped>
                            <b-input :value="placeholder('url')" disabled icon="globe"></b-input>
                            <p class="control">
                                <button class="button is-primary" @click="doCopy(placeholder('url'))">
                                    <b-icon icon="copy" pack="fad"/>
                                </button>
                            </p>
                        </b-field>
                        <div class="buttons">
                            <b-button type="is-primary" @click="isPlaceholderCardModalActive = false">Schließen</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ImageResize from 'quill-image-resize-module'

    export default {
        name: 'Communication',
        components: {},
        props: {},
        data() {
            return {
                editorSettings: {
                    modules: {
                        imageResize: {}
                    }
                },
                customModulesForEditor: [
                    {
                        alias: "imageResize",
                        module: ImageResize
                    }
                ],
                customToolbar: [
                    [{
                        // header: [false, 1, 2, 3, 4, 5, 6]
                        header: [false, 1, 2]
                    }],
                    // ["bold", "italic", "underline", "strike"], // toggled buttons
                    ["bold", "italic", "underline"], // toggled buttons
                    [{
                        align: ""
                    },
                        {
                            align: "center"
                        },
                        {
                            align: "right"
                        },
                        {
                            align: "justify"
                        }
                    ],
                    [{
                        list: "ordered"
                    }, {
                        list: "bullet"
                        // }, {
                        //     list: "check"
                    }],
                    [{
                        color: []
                    }, {
                        background: []
                    }], // dropdown with defaults from theme
                    // ["link", "image", "video"],
                    ["link", "image"],
                    ["clean"]
                ],
                toggleDelete: false,
                search: '',
                temp: {
                    reload: 0
                },
                isCardModalActive: false,
                isPlaceholderCardModalActive: false,
                editableCommunication: {},
                editableCommunicationExternal: {},
                communicationTypes: [
                    {
                        title: 'Mailing',
                        icon: 'envelope',
                        name: 'main',
                        default: 'neues Mailing',
                        create: (template) => this.addCommunication(template)
                    },
                    {
                        title: 'ext. Mailing',
                        icon: 'external-link-square-alt',
                        name: 'external',
                        default: 'neues ext. Mailing',
                        create: (template) => this.templateCommunication(template)
                    },
                    {
                        title: 'Mailing verknüpfen',
                        icon: 'link',
                        name: 'external',
                        default: 'neues ext. Mailing',
                        create: (template) => this.importCommunication(template)
                    }
                ]
            }
        },
        methods: {
            update(id = this.$route.params.id) {
                return true
            },
            saveEvent() {
                this.$root.saveEvent(this.$route.params.id)
            },
            insertPlaceholder() {
                // const quill = document.getElementById('quillEditor')
                document.execCommand('insertText', false /*no UI*/, this.temp.placeholder);
                delete this.temp.placeholder
                this.temp.reload++
            },
            addCommunication(template = {}, init = false) {
                let communication = {}
                communication = Object.assign(communication, template)
                delete (communication.id)
                if (!communication.name) {
                    communication.name = 'Neuer Dialog'
                } else if (!init) {
                    communication.name += ' Kopie'
                }
                if (!communication.type) {
                    communication.type = 'misc'
                }
                if (!communication.senderMail) {
                    communication.senderMail = ''
                }
                if (!communication.senderName) {
                    communication.senderName = ''
                }
                if (!communication.subject) {
                    communication.subject = communication.name
                }
                if (!communication.content) {
                    communication.content = ''
                }
                communication.list = this.$root.event.list
                communication.description = '! Nicht löschen oder bearbeiten ! Event: ' + this.$root.event.name
                this.$root.event.communications.push(communication)
                this.saveEvent()
            },
            templateCommunication(template = {}) {
                let id = this.$root.settings.firms.find(f => f.id == this.$root.event.firm).mailadvancedtemplate
                this.$root.getApi('account/mail/create/' + id, (data) => {
                    let target = Object.assign(template, data)
                    this.$root.event.communications.push(target)
                    this.saveEvent()
                })
            },
            importCommunication(template = {}) {
                this.$buefy.dialog.prompt({
                    message: `Bezeichnung des Mailings?`,
                    inputAttrs: {
                        placeholder: 'Einladungsmailing',
                        maxlength: 50
                    },
                    trapFocus: true,
                    onConfirm: (value) => {
                        template.name = value
                        this.$buefy.dialog.prompt({
                            message: `Mailing ID?`,
                            inputAttrs: {
                                type: 'number',
                                value: '0',
                                maxlength: 6,
                                min: 0
                            },
                            trapFocus: true,
                            onConfirm: (id) => {
                                template.id = id
                                let target = Object.assign({}, template)
                                this.$root.event.communications.push(target)
                                this.saveEvent()
                            }
                        })
                    }
                })

            },
            editExternal(id) {
                this.$root.getApi('account/mail/edit/' + id, data => window.open(data.url, "mwe" + data.sid))
            },
            previewMail(id) {
                this.$root.getApi('account/mail/preview/' + id, data => window.open(data.url, "mwp" + data.sid))
            },
            doCopy: function (text) {
                this.$copyText(text).then((e) => {
                    this.$buefy.toast.open({message: 'Kopiert!', type: 'is-success'})
                }, (e) => {
                    this.$buefy.toast.open({message: 'Nicht kopiert!', type: 'is-danger'})
                })
            },
            placeholder(d = 'url') {
                let url
                url = this.$root.settings.firms.find(f => f.id == this.$root.event.firm).url
                url += this.$root.event.slug + '/'
                url += "[field property='subscriber-id'/]" + '/'
                url += "[field property='code'/]"
                if (d == 'qr') {
                    return "[BARCODE type='QRCode' pixel-size='5' ]" + url + "[/BARCODE]"
                }
                if (d == 'link') {
                    return '[LINK url="' + url + "\" comment='' tracking='auto']Anmeldung[/LINK]"
                }
                return url
            },
            editCommunication(communication) {
                this.editableCommunication = communication
                if (this.editableCommunication.type == 'external') {
                    this.editableCommunicationExternal = {}
                    this.$root.getApi('account/mail/get/' + this.editableCommunication.id, data => {
                        this.editableCommunicationExternal = data
                        this.isCardModalActive = true
                    })
                } else {
                    this.editableCommunication.imprint = this.$root.settings.firms.find(element => element.id == this.$root.event.firm).imprint
                    this.editableCommunication.updated = true
                    this.isCardModalActive = true
                }

            },
            saveCommunication() {
                this.isCardModalActive = false
                this.$root.saveEvent(this.$route.params.id, true)
            },
            activateCommunication() {
                this.isCardModalActive = false
                this.$root.saveEvent(this.$route.params.id, true)
            },
            icon(type = 'main') {
                let find = this.communicationTypes.find(function (element) {
                    return element.name == type
                })
                return find.icon
            },
            removeCommunication(old, index) {
                this.$buefy.dialog.confirm({
                    title: 'Mail löschen?',
                    message: 'Sind Sie sicher, dass Sie die <br>Mail <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                    confirmText: 'Mail löschen',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$root.getApi('account/mail/delete/' + old.id, (data) => {
                            this.$root.event.communications.splice(index, 1)
                            this.saveEvent()
                            this.$buefy.toast.open({
                                message: 'Die Mail <b>' + old.name + '</b> wurde gelöscht',
                                type: 'is-success'
                            })
                        })
                    }
                })
            },
            handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
                // An example of using FormData
                // NOTE: Your key could be different such as:
                // formData.append('file', file)

                this.$root.uploadAsset(file, data => {
                    Editor.insertEmbed(cursorLocation, "image", data.url);
                    resetUploader();
                })

            }
        },
        created() {
            // fetch the data when the view is created and the data is
            // already being observed
            if (!Array.isArray(this.$root.event.communications)) {
                this.$root.event.communications = []
            }
            this.update()
        },
        computed: {
            filtered() {
                var origin = this.$root.event.communications,
                    filtered = [],
                    patt = new RegExp(this.search, "i");

                origin.forEach(entry => {
                    if (typeof entry.id !== 'undefined') {
                        filtered.push(entry)
                        return
                    }
                })
                if (this.search == '') {
                    return filtered
                }
                if (this.search.length < 3) {
                    return filtered
                }
                filtered = []
                origin.forEach(entry => {
                    if (patt.test(entry.name) && typeof entry.id !== 'undefined') {
                        filtered.push(entry)
                        return
                    }
                    if (patt.test(entry.subject) && typeof entry.id !== 'undefined') {
                        filtered.push(entry)
                        return
                    }
                })
                return filtered
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .c-preview {
        width: 50px;
    }
</style>
<style>
    .ql-picker.ql-placeholder {
        width: 118px;
    }

    .ql-picker.ql-placeholder > span.ql-picker-label::before {
        content: 'Placeholders';
    }

    .ql-picker.ql-placeholder > span.ql-picker-options > span.ql-picker-item::before {
        content: attr(data-label);
    }
</style>
